import { SimpleModal } from "../../../../../components/Modal";
import ModalTitleContainer from "../../../../../components/Modal/components/ModalTitleContainer";
import { StyledOkButton, StyledDescription } from "./JobBoardModal.styles";

interface JobBoardModalProps {
    isOpen: boolean
    title: string
    description: string
    onClose: () => void
}
const JobBoardModal = ({isOpen, title, description, onClose}: JobBoardModalProps) => {
    return (
            <SimpleModal
                isOpen={isOpen}
                onClose={onClose}
            >
                <ModalTitleContainer
                    title={title}
                    onClose={onClose}
                />
                <StyledDescription>
                    {description}
                </StyledDescription>

                <StyledOkButton
                    variant="contained"
                    color="primary"
                    size="large"
                    id="continue-button"
                    className="bigButtonInNewStyle"
                    onClick={onClose}
                >
                    Ok
                </StyledOkButton>
            </SimpleModal>
    )
}

export default JobBoardModal;